import { useState } from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { LangProvider } from './context/LangContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Collections from './components/Collections';
import Gallery from './components/Gallery';
import Heritage from './components/Heritage';
import Testimonials from './components/Testimonials';
import AppointmentCTA, { BookingModal } from './components/AppointmentCTA';

import Location from './components/Location';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import './App.css';

function AppInner() {
  const [bookingOpen, setBookingOpen] = useState(false);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Collections />
        <Gallery />

        <Heritage />
        <Testimonials />
        <AppointmentCTA onBook={() => setBookingOpen(true)} />
        <Location />
      </main>
      <Footer />
      <FloatingCTA />
      {bookingOpen && <BookingModal onClose={() => setBookingOpen(false)} />}
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <LangProvider>
        <AppInner />
      </LangProvider>
    </ThemeProvider>
  );
}
